<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    updateDocumentTitle(unreadMessages) {
      document.title =
        unreadMessages > 0
          ? `(${unreadMessages}) Humaniz.io - Modern agent recruiting`
          : 'Humaniz.io - Modern agent recruiting';
    },
  },
  mounted() {
    const unreadMessages = this.$store.state.general.currentUserAccountDetails.unreadMessages;
    this.updateDocumentTitle(unreadMessages);

    this.$watch(
      () => this.$store.state.general.currentUserAccountDetails.unreadMessages,
      newUnreadMessages => {
        this.updateDocumentTitle(newUnreadMessages);
      }
    );
  },
};
</script>
